import { useMe } from '@/hooks/api/0050_me';
import { Navigate, useParams } from 'react-router-dom';
import { useWorkspace } from '@/hooks/api/0101_workspace';
import { useEffect, useState } from 'react';
import { useCurrentWorkspace } from '@/providers/WorkspaceProvider';

type Props = { children?: React.ReactNode };

export const RequireWorkspaceMember = (props: Props) => {
  const { identifier } = useParams();
  const { data, status, error } = useWorkspace(identifier!);
  const { _w_, set_w_, me, setMe } = useCurrentWorkspace();

  useEffect(() => {
    if (data) {
      set_w_((d) => data.workspace);
      setMe((d) => data.user);
    }
  }, [data]);

  if (status == 'error') {
    return <Navigate replace to={'/workspaces'} />;
  }

  if (_w_ && me) {
    return <>{props.children}</>;
  }

  return <></>;
};
